import {
  Box,
  CardMedia,
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { Branding } from "../../branding";
import Footer from "../Footer/Footer";

const useStyles = makeStyles((theme) => ({
  cardMedia: {
    width: 200,
    height: 90,
    backgroundSize: "contain",
  },
  messageHeading: {
    fontSize: "24px",
    fontWeight: '700',
    fontFamily: 'Roboto, sans-serif',
    color: Branding.primary,
    margin: '8px 0px 8px 0px'
  },
  message: {
    fontSize: "16px",
    fontWeight: '400',
    fontFamily: 'Roboto, sans-serif',
    color: "rgba(0,0,0,0.60)",
    align: 'center',
    padding: '0px 12px 0px 12px'
  },
  spinnerStyle: {
    color: "#0C938F",
    margin: '8px 0px 8px 0px'
  },
  mainGrid: {
    justifyContent: 'space-evenly',
    minHeight: '100vh'
  },
  footerGrid: { marginTop: '10em' }
}));

const mapStateToProps = (state) => {
  return {
    user: state.app.user,
    lang: state.app.lang,
    tos: state.app.tos,
  };
};

const WaitingRoom = (props) => {
  const classes = useStyles();
  React.useEffect(() => { }, []);
  const waitingRoomWaitingTime = sessionStorage.getItem(
    "waitingRoomWaitingTime"
  );

  return (
    <>
      <Grid container spacing={2} className={classes.mainGrid}>
        <Grid style={{ paddingLeft: '20%', paddingTop: '6em', paddingBottom: '4em' }} container item xs={12} spacing={3}>
          <CardMedia
            className={classes.cardMedia}
            image={
              "https://s3.amazonaws.com/pe-newco-media/wp-content/uploads/2022/07/19122350/YouScience_1320x393_transparent.png"
            }
            title={Branding.appName}
          />
        </Grid>
        <Grid
          alignItems="center"
          justifyContent="center"
          spacing={0}
          container
          xs={12}
          item
        >
          <Box component={'div'} align="center" >
            <CircularProgress className={classes.spinnerStyle} variant="indeterminate" thickness={5} size={'2em'} />
            <Typography className={classes.messageHeading} align="center">
              You’re almost in!
            </Typography>
            <Typography style={{ marginBottom: '2em' }} className={classes.message} align="center">
              Lots of users are logging in right now, so we're making sure everything runs smoothly.<br />
              It shouldn't take more than {waitingRoomWaitingTime ? waitingRoomWaitingTime * 60 : 60} seconds . Thanks for your patience.
            </Typography>
          </Box>
        </Grid>
        <Grid container item xs={12} spacing={0} className={classes.footerGrid}>
          <Footer></Footer>
        </Grid>
      </Grid>

    </>
  );
};

export default connect(mapStateToProps, {})(WaitingRoom);
